

<template>
  <div class="coloursequence">
    <el-dialog
      title="数量"
      width="922px"
      append-to-body
      :visible.sync="visible"
      @close="clearData"
      :show="show"
      :close-on-click-modal="false"
    >
      <div style="height: 390px">
        <div class="head_Part">
          <div style="padding: 10px 0 10px 14px">
            <span style="font-size: 20px; font-weight: bold">序列号录入</span>
            <span style="font-size: 18px"
              >商品名称：{{ tableData.FullName }}</span
            >
          </div>
          <div
            class="SerialTable_boxs SerialTable_box"
            id="key_content"
            ref="key_content"
          >
            <div v-if="!checked" class="inputserials">
              <el-input
                id="inputserialsn_1"
                ref="inputserialsn_1"
                size="mini"
                class="sty_collsls"
                style="margin-bottom: 8px"
                v-model="SerialNo"
                @keyup.enter.native="enterkeyxlhs(1, true)"
              >
                <span slot="prefix" class="label_sty">序列号 :</span>
              </el-input>
            </div>
            <div v-if="checked" class="inputserials inputserialssd">
              <el-input
                id="inputserialsn_2"
                ref="inputserialsn_2"
                size="mini"
                class="sty_collsls"
                style="margin-bottom: 8px"
                v-model="serialnumberrise"
                @keyup.enter.native="enterkeyxlhs(2, true)"
              >
                <span slot="prefix" class="label_sty">序列号起 :</span>
              </el-input>
              <el-input
                id="inputserialsn_3"
                ref="inputserialsn_3"
                size="mini"
                class="sty_collsls"
                style="margin-bottom: 8px"
                v-model="serialnumberstop"
                @keyup.enter.native="enterkeyxlhs(3, true)"
              >
                <span slot="prefix" class="label_sty">序列号止 :</span>
              </el-input>
            </div>
            <!-- <div class="sty_collslsb">
              <div>
                <el-button size="mini" style="margin-right: 10px" @click="downlclick">下载序列号模板</el-button>
              </div>
              <el-upload
                style="border:none;padding:0"
                :action="'/index/Export_Excel/ImportSerialNo?'+'jparams='+JSON.stringify(jparam)"
                :on-success="handleAvatarSuccess"
                accept="xls/xlsx"
                :show-file-list="false"
              >
                <el-button size="mini">导入序列号</el-button>
              </el-upload>
            </div>-->
          </div>
          <div style="display: flex; flex-wrap: wrap">
            <el-input
              id="inputserialsn_4"
              ref="inputserialsn_4"
              size="mini"
              class="sty_collsls"
              v-model="QtyData.JobNumber"
              @keyup.enter.native="enterkeyxlhs(4, true)"
            >
              <span slot="prefix" class="label_sty">批号 :</span>
            </el-input>
            <el-input
              id="inputserialsn_5"
              ref="inputserialsn_5"
              size="mini"
              class="sty_collsls"
              v-model="QtyData.Price"
              @keyup.enter.native="enterkeyxlhs(5, true)"
              @input="
                QtyData.Price = QtyData.Price.replace(
                  /^\D*(\d*(?:\.\d{0,6})?).*$/g,
                  '$1'
                )
              "
            >
              <span slot="prefix" class="label_sty">单价 :</span>
            </el-input>
            <el-input
              id="inputserialsn_6"
              ref="inputserialsn_6"
              size="mini"
              class="sty_collsls"
              v-model="QtyData.Color"
              @keyup.enter.native="enterkeyxlhs(6, true)"
            >
              <span slot="prefix" class="label_sty">颜色 :</span>
            </el-input>
          </div>
          <div style="display: flex">
            <div
              style="
                width: 240px;
                height: 28px;
                border: 1px solid #dcdfe6;
                display: flex;
                border-radius: 4px;
                margin: 8px 0 0 13px;
              "
              class="date_picker"
            >
              <span
                style="
                  white-space: nowrap;
                  line-height: 28px;
                  margin-left: 10px;
                  font-weight: bolder;
                  color: #333;
                  font-size: 12px;
                "
                >生产日期：</span
              >
              <el-date-picker
                id="inputserialsn_7"
                @keyup.enter.native="enterkeyxlhs(7, true)"
                v-model="QtyData.OutFactoryDate"
                type="date"
                placeholder="生产日期"
                @change="changepicker('OutFactoryDate')"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
            <div
              style="
                width: 240px;
                height: 28px;
                border: 1px solid #dcdfe6;
                display: flex;
                border-radius: 4px;
                margin: 8px 0 0 13px;
              "
              class="date_picker"
            >
              <span
                style="
                  white-space: nowrap;
                  line-height: 28px;
                  margin-left: 10px;
                  font-weight: bolder;
                  color: #333;
                  font-size: 12px;
                "
                >到期日期：</span
              >
              <el-date-picker
                id="inputserialsn_8"
                v-model="QtyData.MaturityDate"
                type="date"
                placeholder="到期日期"
                value-format="yyyy-MM-dd"
                @change="changepicker('MaturityDate')"
              ></el-date-picker>
            </div>
            <div>
              <el-button type="primary" size="mini" @click="clickDATA"
                >确认加入</el-button
              >
            </div>
          </div>
        </div>
        <div class="body_Part">
          <vxe-table
            border
            height="180px"
            ref="xTable"
            align="center"
            highlight-hover-row
            highlight-current-row
            :data="TableDataS"
            :header-cell-style="{
              background: '#eef1f6',
              color: '#000',
              fontSize: '16px',
              height: '37px',
              padding: '0',
              fontWeight: 'bold',
            }"
            :footer-row-style="{
              background: '#eef1f6',
              color: '#000',
              fontSize: '14px',
              height: '30px',
              padding: '0',
            }"
            :footer-cell-style="{
              background: '#fff',
              color: '#000',
              fontSize: '14px',
              height: '30px',
              padding: '0',
            }"
          >
            <vxe-table-column
              type="index"
              align="center"
              width="60"
              fixed="left"
            >
              <template v-slot:header>
                <span>行号</span>
              </template>
              <template v-slot="{ column, rowIndex }">{{
                rowIndex + 1
              }}</template>
            </vxe-table-column>
            <vxe-table-column
              width="100"
              align="center"
              title="操作"
              fixed="left"
            >
              <template v-slot="{ row, rowIndex }">
                <el-button
                  type="text"
                  @click.native.prevent="deleteRow(rowIndex)"
                  >移除</el-button
                >
              </template>
            </vxe-table-column>
            <template v-for="(item, index) in ObtainHeader">
              <vxe-table-column
                width="160"
                :key="index"
                :field="item.Key"
                :title="item.Rename"
                align="center"
              >
                <template v-slot="{ row, rowIndex }">
                  <div class="input_box ub ub-ac">
                    <input
                      v-if="
                        item.Key != 'MaturityDate' &&
                        item.Key != 'OutFactoryDate'
                      "
                      v-model.lazy="row[item.Key]"
                      class="input_stt"
                    />
                    <div
                      v-else-if="
                        item.Key == 'MaturityDate' ||
                        item.Key == 'OutFactoryDate'
                      "
                      style="width: 100%; height: 100%"
                      class="input_box_picker"
                    >
                      <el-date-picker
                        v-model.lazy="row[item.Key]"
                        type="date"
                        class="input_stt"
                        value-format="yyyy-MM-dd"
                        @focus="focuspicker(row[item.Key])"
                        @change="
                          changepicker_x($event, row, item.Key, rowIndex)
                        "
                      ></el-date-picker>
                    </div>
                    <div v-else class="only_show_div">{{ row[item.Key] }}</div>
                  </div>
                </template>
              </vxe-table-column>
            </template>
          </vxe-table>
        </div>
        <div class="foot_Part">
          <div>
            <el-checkbox v-model="checked">批量录入</el-checkbox>
            <vxe-button @click="removeSelecteds">删除全部</vxe-button>
          </div>
          <div>
            <el-button size="mini" type="primary" @click="clickDetermine"
              >确定</el-button
            >
            <el-button size="mini" @click="$emit('update:show', false)"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
export default {
  data() {
    return {
      tableData: "", // 当前数据
      visible: this.show,
      QtyData: {
        JobNumber: "", // 批号
        MaturityDate: "", // 生产日期：
        OutFactoryDate: "", // 到期日期
        Price: "", // 单价
        sn: "", // 序列号
        Color: "", // 颜色
        Memo: "", // 备注
      },
      checked: false,
      SerialNo: "", // 序列号
      serialnumberrise: "", // 序列号起
      serialnumberstop: "", // 序列号止
      TableDataS: [],
      ObtainHeader: [
        { Key: "sn", Rename: "序列号" },
        { Key: "Price", Rename: "单价" },
        { Key: "Color", Rename: "颜色" },
        { Key: "JobNumber", Rename: "批号" },
        { Key: "MaturityDate", Rename: "到期日期" },
        { Key: "OutFactoryDate", Rename: "生产日期" },
        { Key: "Memo", Rename: "备注" },
      ], // 多单位 表头
      MaturityDateOutFactoryDate: "",
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 聚焦保存数据用于回填
    focuspicker(row) {
      this.MaturityDateOutFactoryDate = row;
    },
    changepicker(Key) {
      let data = this.$attrs.tableData;
      let row = this.QtyData[Key];
      // 获取指定日期前一天后一天 -1 前一天  1 后一天
      function getNextDate(date, day) {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m =
          dd.getMonth() + 1 < 10
            ? "0" + (dd.getMonth() + 1)
            : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "-" + m + "-" + d;
      }

      if (Key == "MaturityDate" && this.QtyData.MaturityDate != null) {
        // 天  d
        if (data.DateType == 0) {
          if (data.UseFullLifeDay == 0) {
            this.QtyData.OutFactoryDate = this.QtyData.MaturityDate;
          } else {
            this.QtyData.OutFactoryDate = getNextDate(
              tool.DateAdds("d", data.UseFullLifeDay, row, false),
              1
            );
          }
        }
        // 月  m
        if (data.DateType == 1) {
          if (data.UseFullLifeDay == 0) {
            this.QtyData.OutFactoryDate = this.QtyData.MaturityDate;
          } else {
            this.QtyData.OutFactoryDate = getNextDate(
              tool.DateAdds("m", data.UseFullLifeDay, row, false),
              1
            );
          }
        }
        // 年 y
        if (data.DateType == 2) {
          if (data.UseFullLifeDay == 0) {
            this.QtyData.OutFactoryDate = this.QtyData.MaturityDate;
          } else {
            this.QtyData.OutFactoryDate = getNextDate(
              tool.DateAdds("y", data.UseFullLifeDay, row, false),
              1
            );
          }
        }
      }
      if (Key == "OutFactoryDate" && this.QtyData.OutFactoryDate != null) {
        // 天  d
        if (data.DateType == 0) {
          if (data.UseFullLifeDay == 0) {
            this.QtyData.MaturityDate = this.QtyData.OutFactoryDate;
          } else {
            this.QtyData.MaturityDate = getNextDate(
              tool.DateAdds("d", data.UseFullLifeDay, row, true),
              -1
            );
          }
        }
        // 月  m
        if (data.DateType == 1) {
          if (data.UseFullLifeDay == 0) {
            this.QtyData.MaturityDate = this.QtyData.OutFactoryDate;
          } else {
            this.QtyData.MaturityDate = getNextDate(
              tool.DateAdds("m", data.UseFullLifeDay, row, true),
              -1
            );
          }
        }
        // 年 y
        if (data.DateType == 2) {
          if (data.UseFullLifeDay == 0) {
            this.QtyData.MaturityDate = this.QtyData.OutFactoryDate;
          } else {
            this.QtyData.MaturityDate = getNextDate(
              tool.DateAdds("y", data.UseFullLifeDay, row, true),
              -1
            );
          }
        }
      }
    },
    // 生产到期日期
    changepicker_x(row, data, Key, inxex) {
      let data_s = this.$attrs.tableData;
      // DateType 时间类型 0 日 1 月 2 年 生产 OutFactoryDate  到期  MaturityDate
      // 获取指定日期前一天后一天 date：参数指定时间 day: -1 前一天  1 后一天
      function getNextDate(date, day) {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m =
          dd.getMonth() + 1 < 10
            ? "0" + (dd.getMonth() + 1)
            : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "-" + m + "-" + d;
      }
      var date_row = new Date(row);
      if (Key == "MaturityDate" && this.QtyData.MaturityDate != null) {
        // 天  d
        if (data_s.DateType == 0) {
          if (data_s.UseFullLifeDay == 0) {
            this.TableDataS[inxex].OutFactoryDate = row;
            this.TableDataS[inxex].MaturityDate = row;
          } else {
            this.TableDataS[inxex].OutFactoryDate = getNextDate(
              tool.DateAdds("d", data_s.UseFullLifeDay, row, false),
              1
            );
          }
        }
        // 月  m
        if (data_s.DateType == 1) {
          if (data_s.UseFullLifeDay == 0) {
            this.TableDataS[inxex].OutFactoryDate = row;
            this.TableDataS[inxex].MaturityDate = row;
          } else {
            this.TableDataS[inxex].OutFactoryDate = getNextDate(
              tool.DateAdds("m", data_s.UseFullLifeDay, row, false),
              1
            );
          }
        }
        // 年 y
        if (data_s.DateType == 2) {
          if (data_s.UseFullLifeDay == 0) {
            this.TableDataS[inxex].OutFactoryDate = row;
            this.TableDataS[inxex].MaturityDate = row;
          } else {
            this.TableDataS[inxex].OutFactoryDate = getNextDate(
              tool.DateAdds("y", data_s.UseFullLifeDay, row, false),
              1
            );
          }
        }
      }
      if (Key == "OutFactoryDate" && this.QtyData.OutFactoryDate != null) {
        // 天  d
        if (data_s.DateType == 0) {
          if (data_s.UseFullLifeDay == 0) {
            this.TableDataS[inxex].OutFactoryDate = row;
            this.TableDataS[inxex].MaturityDate = row;
          } else {
            this.TableDataS[inxex].MaturityDate = getNextDate(
              tool.DateAdds("d", data_s.UseFullLifeDay, row, true),
              -1
            );
          }
        }
        // 月  m
        if (data_s.DateType == 1) {
          if (data_s.UseFullLifeDay == 0) {
            this.TableDataS[inxex].OutFactoryDate = row;
            this.TableDataS[inxex].MaturityDate = row;
          } else {
            this.TableDataS[inxex].MaturityDate = getNextDate(
              tool.DateAdds("m", data_s.UseFullLifeDay, row, true),
              -1
            );
          }
        }
        // 年 y
        if (data_s.DateType == 2) {
          if (data_s.UseFullLifeDay == 0) {
            this.TableDataS[inxex].OutFactoryDate = row;
            this.TableDataS[inxex].MaturityDate = row;
          } else {
            this.TableDataS[inxex].MaturityDate = getNextDate(
              tool.DateAdds("y", data_s.UseFullLifeDay, row, true),
              -1
            );
          }
        }
      }
      this.$refs.xTable.updateData();
      this.$refs.xTable.updateFooter();
    },

    // 回车
    enterkeyxlhs(index, show) {
      if (!this.checked) {
        if (index != 1) {
          index = index + 1;
          let sd = "inputserialsn_" + index;
          document.getElementById(sd).focus();
        } else {
          document.getElementById("inputserialsn_4").focus();
        }
      }
      // console.log(index, show);
      let adg = [];
      // console.log("inputserialsn_" + index);
      // this.$refs.inputserialsn_5.focus();
      // console.log(this.$refs);
      // adg.push(...this.$refs);
      // console.log(adg);
    },
    // 删除全部
    removeSelecteds() {
      this.TableDataS = [];
    },
    // 删除
    deleteRow(index) {
      // this.tableDat = tableDat;
      this.TableDataS.splice(index, 1);
    },

    clickDetermine() {
      let QTYs = 0; // 数量
      let Totals = 0; //金额
      let Prices = 0; //单价
      this.TableDataS.map((item) => {
        Totals += Number(item.Price);
      });
      if (Number(this.TableDataS.length) != 0) {
        Prices = (Number(Totals) / Number(this.TableDataS.length)).toFixed(
          tool.getLocal("get_config").moneyPoint
        );
      }
      // if (Number(this.TableDataS.length) != 0) {
      this.$emit(
        "chooseBack",
        this.TableDataS,
        this.TableDataS.length,
        Totals,
        Prices
      );
      // }
      this.$emit("update:show", false);
    },
    // 确认 添加数据
    clickDATA() {
      if (!this.checked) {
        if (this.SerialNo != "") {
          this.TableDataS.push({
            Memo: "",
            JobNumber: this.QtyData.JobNumber,
            OutFactoryDate: this.QtyData.OutFactoryDate,
            MaturityDate: this.QtyData.MaturityDate,
            Color: this.QtyData.Color,
            Price: this.QtyData.Price,
            sn: this.SerialNo,
          });
          // console.log(this.TableDataS);
        } else {
          tool.popMessage(this, "序列号不能为空", "warning");
        }
      } else {
        // 如果是批量录入需要生成区间序列号
        this.enterkeyxlh();
      }
      this.QtyData = {
        JobNumber: "", // 批号
        MaturityDate: "", // 生产日期：
        OutFactoryDate: "", // 到期日期
        Price: "", // 单价
        Sn: "", // 序列号
        Color: "", // 颜色
        Memo: "", // 备注
      };
      this.SerialNo = ""; // 序列号
      this.serialnumberrise = ""; // 序列号起
      this.serialnumberstop = ""; // 序列号止
    },
    enterkeyxlh() {
      // 有三种情况
      /*
       *    1丶 序列号起大于序列号止
       *         正常获取
       *    2丶 序列号起小于序列号止
       *         提升不可生成
       *    3丶 序列号起等于于序列号止
       *         只生成一个
       *       注释：存在字母数字穿插使用需要进行分离
       */
      if (this.serialnumberrise != "" && this.serialnumberstop != "") {
        let re = /([0-9]+)$/i;
        let rise = this.serialnumberrise.match(re)[0];
        let stop = this.serialnumberstop.match(re)[0];
        if (
          this.getLength(this.serialnumberrise) ===
          this.getLength(this.serialnumberstop)
        ) {
          if (
            this.serialnumberrise.split(rise)[0] ===
              this.serialnumberstop.split(stop)[0] &&
            this.serialnumberrise.split(rise)[0] != "" &&
            this.serialnumberstop.split(stop)[0] != ""
          ) {
            let res = /^0*/;
            let rises = rise.match(res)[0];
            let stops = stop.match(res)[0];
            if (
              Number(
                this.serialnumberrise.split(
                  this.serialnumberrise.split(rise)[0]
                )[1]
              ) <=
              Number(
                this.serialnumberstop.split(
                  this.serialnumberstop.split(stop)[0]
                )[1]
              )
            ) {
              let a = {
                prefix: this.serialnumberrise.split(rise)[0],
                Suffix: Number(
                  this.serialnumberrise.split(
                    this.serialnumberrise.split(rise)[0]
                  )[1]
                ),
              };
              let b = {
                prefix: this.serialnumberstop.split(stop)[0],
                Suffix: Number(
                  this.serialnumberstop.split(
                    this.serialnumberstop.split(stop)[0]
                  )[1]
                ),
              };
              this.AddNumber(a, b, this.getLength(this.serialnumberrise), 1);
            } else {
              tool.popMessage(this, "序列号格式不正确", "warning");
            }
          } else if (
            this.serialnumberrise.split(rise)[0] ===
              this.serialnumberstop.split(stop)[0] &&
            this.serialnumberrise.split(rise)[0] == "" &&
            this.serialnumberstop.split(stop)[0] == ""
          ) {
            if (
              Number(this.serialnumberrise) <= Number(this.serialnumberstop)
            ) {
              let a = {
                prefix: "",
                Suffix: Number(this.serialnumberrise),
              };
              let b = {
                prefix: "",
                Suffix: Number(this.serialnumberstop),
              };
              this.AddNumber(a, b, this.getLength(this.serialnumberrise), 2);
            } else {
              tool.popMessage(this, "序列号格式不正确", "warning");
            }
          } else {
            tool.popMessage(this, "序列号格式不正确", "warning");
          }
        } else {
          tool.popMessage(this, "序列号格式不正确", "warning");
        }
      } else {
        tool.popMessage(this, "序列号不能为空", "warning");
      }
    },

    // 获取字符串长度
    getLength(val) {
      var str = new String(val);
      var bytesCount = 0;
      for (var i = 0, n = str.length; i < n; i++) {
        var c = str.charCodeAt(i);
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          bytesCount += 1;
        } else {
          bytesCount += 2;
        }
      }
      return bytesCount;
    }, // 判断数据是否重复
    isAllEqual(array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== array[0];
        });
      } else {
        return true;
      }
    },
    // 添加序列号
    AddNumber(rise, stop, lgh, rowIndex) {
      let add = "0";
      if (rowIndex == 1) {
        let size = this.getLength(rise.prefix);
        for (let index = rise.Suffix; index <= stop.Suffix; index++) {
          if (this.getLength(String(index)) + size < lgh && size != 0) {
            let s = "";
            for (
              let i = Number(this.getLength(String(index))) + size;
              i < Number(lgh);
              i++
            ) {
              s = "0" + s;
            }

            let asdf = [];
            // 如果出现重复放一个true到asdf中 反之放入false 在判断数组是否全等
            this.TableDataS.forEach((item) => {
              if (String(item.sn) == String(rise.prefix + s + index)) {
                asdf.push(true);
              } else {
                asdf.push(false);
              }
            });
            if (this.isAllEqual(asdf)) {
              this.TableDataS.push({
                sn: String(rise.prefix + s + index),
                Memo: "",
                JobNumber: this.QtyData.JobNumber,
                OutFactoryDate: this.QtyData.OutFactoryDate,
                MaturityDate: this.QtyData.MaturityDate,
                Color: this.QtyData.Color,
                Price: this.QtyData.Price,
              });
            }
          } else {
            let asdf = [];
            // 如果出现重复放一个true到asdf中 反之放入false 在判断数组是否全等
            this.TableDataS.forEach((item) => {
              if (String(item.sn) == String(rise.prefix + index)) {
                asdf.push(true);
              } else {
                asdf.push(false);
              }
            });
            if (this.isAllEqual(asdf)) {
              this.TableDataS.push({
                sn: String(rise.prefix + index),
                Memo: "",
                JobNumber: this.QtyData.JobNumber,
                OutFactoryDate: this.QtyData.OutFactoryDate,
                MaturityDate: this.QtyData.MaturityDate,
                Color: this.QtyData.Color,
                Price: this.QtyData.Price,
              });
            }
          }
        }
      } else if (rowIndex == 2) {
        for (let index = rise.Suffix; index <= stop.Suffix; index++) {
          if (this.getLength(String(index)) < lgh) {
            let s = "" + index;
            for (
              let i = Number(this.getLength(String(index)));
              i < Number(lgh);
              i++
            ) {
              s = "0" + s;
            }
            // 判断 TableDataS 中是否有数据

            let asdf = [];
            // 如果出现重复放一个true到asdf中 反之放入false 在判断数组是否全等
            this.TableDataS.forEach((item) => {
              if (String(item.sn) == String(s)) {
                asdf.push(true);
              } else {
                asdf.push(false);
              }
            });
            if (this.isAllEqual(asdf)) {
              this.TableDataS.push({
                sn: String(s),
                Memo: "",
                JobNumber: this.QtyData.JobNumber,
                OutFactoryDate: this.QtyData.OutFactoryDate,
                MaturityDate: this.QtyData.MaturityDate,
                Color: this.QtyData.Color,
                Price: this.QtyData.Price,
              });
            }
          } else {
            let asdf = [];
            // 如果出现重复放一个true到asdf中 反之放入false 在判断数组是否全等
            this.TableDataS.forEach((item) => {
              if (String(item.sn) == String(index)) {
                asdf.push(true);
              } else {
                asdf.push(false);
              }
            });
            if (this.isAllEqual(asdf)) {
              this.TableDataS.push({
                sn: String(index),
                Memo: "",
                JobNumber: this.QtyData.JobNumber,
                OutFactoryDate: this.QtyData.OutFactoryDate,
                MaturityDate: this.QtyData.MaturityDate,
                Color: this.QtyData.Color,
                Price: this.QtyData.Price,
              });
            }
          }
        }
      }
    },
    // 退出清除数据
    clearData() {
      // 退出前是数据初始化
      this.$emit("update:show", false);
    },
  },
  watch: {
    show() {
      this.visible = this.show;
      setTimeout(() => {
        this.$refs.xTable.updateData();
        this.$refs.xTable.updateFooter();
      }, 400);
    },
    visible: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.tableData = this.$attrs.tableData;

          this.TableDataS = this.$attrs.tableData.QtyData;
          this.QtyData = {
            JobNumber: "", // 批号
            MaturityDate: "", // 生产日期：
            OutFactoryDate: "", // 到期日期
            Price: "", // 单价
            Sn: "", // 序列号
            Color: "", // 颜色
            Memo: "", // 备注
          };
          this.SerialNo = ""; // 序列号
          this.serialnumberrise = ""; // 序列号起
          this.serialnumberstop = ""; // 序列号止
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 20px !important;
}
.head_Part {
  height: 166px;
  border-radius: 10px;
  box-shadow: 0px 0px 7px #ccc;
  margin-bottom: 5px;
  .sty_collsls {
    width: 200px;
    margin-left: 13px;
  }
  /deep/ .el-input--prefix .el-input__inner {
    padding-left: 46px;
  }
  .inputserials {
    /deep/ .el-input--prefix .el-input__inner {
      padding-left: 55px;
    }
  }
  .inputserialssd {
    /deep/ .el-input--prefix .el-input__inner {
      padding-left: 65px;
    }
  }
  /deep/ .el-input--medium .el-input__icon {
    line-height: 28px;
  }
  .label_sty {
    color: #333;
    font-size: 12px;
    padding: 0 5px;
    height: 100%;
    line-height: 28px;
    font-weight: bold;
    display: inline-block;
  }

  .date_picker {
    .el-input--medium,
    .el-select--medium {
      height: 28px;
    }
    /deep/ .el-input--prefix .el-input__inner {
      height: 28px;
      border: 0;
      width: 100%;
    }
  }
  .el-button--mini,
  .el-button--mini.is-round {
    padding: 8px 18px;
    position: relative;
    top: 9px;
    right: -264px;
  }
}
.body_Part {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  /deep/ .el-input__prefix,
  .el-input__suffix {
    top: -3px;
  }
  /deep/ .el-input--medium .el-input__inner {
    height: 28px;
    line-height: 28px;
    border: 0;

    text-align: center;
  }
  /deep/.vxe-table .vxe-cell {
    padding: 0 0px;
    height: 30px;
    overflow: hidden;
    line-height: 30px;
  }
  /deep/.vxe-table .vxe-body--column:not(.col--ellipsis),
  .vxe-table .vxe-footer--column:not(.col--ellipsis),
  .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 0;
  }
  .input_stt {
    height: 30px;
    width: 100%;
    display: block;
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    padding: 0 !important;
    background: #fff;
    display: block;
    box-sizing: border-box;
    padding: 0 0;
    border: 0; //可根据需要修改有无边框显示长度和宽带
    overflow: hidden;
    // outline: none;
    text-align: center;
  }
}
.el-button--medium {
  padding: 8px 12px;
}
.foot_Part {
  display: flex;
  justify-content: space-between;
  margin: 10px 0 0 0;
}

.input_box_picker {
  /deep/.el-input--medium .el-input__icon {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/coloursequence/coloursequence.vue